/* The two homepage test variants.

   Rudi wants three versions of the preview homepage measured against each
   other:

     new  the current page, untouched (this file does nothing there)
     b    ask what the visitor is shopping for, then reorder the page so
          their answer leads and the other gender follows underneath
     c    the two heroes as one full-width carousel that advances when a
          clip finishes, with the four small tiles left alone

   Both variants are the SAME markup as the control. Nothing is duplicated
   in Liquid: the section renders one page and this file rearranges it, which
   is the only way three versions stay in step as the page keeps changing.
   The mode arrives on the root as data-ejh-mode, set per template. */
(function () {
  var root = document.querySelector('[data-ejh-root]');
  if (!root) { return; }

  var mode = root.getAttribute('data-ejh-mode');
  if (mode !== 'ask' && mode !== 'carousel') { return; }

  /* A refused autoplay must not be silent.

     Muted autoplay is allowed almost everywhere, but not quite: iOS Low
     Power Mode, Safari's per-site settings and some data savers all reject
     play() with NotAllowedError. Both drivers here were swallowing that
     rejection, which leaves a banner sitting on a still with nothing to say
     why. ejh-home.js already had this pattern for its rotation; these two
     now share it -- park the request, and run it on the first real
     interaction the page gets. */
  var waiting = [];
  var armed = false;
  function onRefusal(fn) {
    waiting.push(fn);
    if (armed) { return; }
    armed = true;
    var evts = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    var go = function () {
      evts.forEach(function (e) { document.removeEventListener(e, go, true); });
      var queue = waiting.slice();
      waiting = [];
      armed = false;
      queue.forEach(function (f) { try { f(); } catch (e) {} });
    };
    evts.forEach(function (e) { document.addEventListener(e, go, true); });
  }

  /* play() returns a promise; a rejection with NotAllowedError means the
     browser said no, anything else means the media itself failed. */
  function attempt(v, onOk, onNo) {
    var p = v.play();
    if (!p || !p.then) { if (onOk) { onOk(); } return; }
    p.then(function () { if (onOk) { onOk(); } }, function (err) {
      if (err && err.name === 'NotAllowedError' && onNo) { onNo(); }
    });
  }

  function tilesIn(el) {
    return Array.prototype.slice.call(el.querySelectorAll('[data-ejh-tile]'));
  }

  /* Every tile already prints the group it belongs to as its eyebrow, so the
     split costs no new settings and cannot drift from what is on screen. */
  function genderOf(tile) {
    var el = tile.querySelector('.ejh-tile__eyebrow');
    /* The label now shows the product type (SEO notes, #4), so the group
       comes from data-for (snippets/ejh-tile.liquid); the text is the
       fallback for a tile that has no data-for. */
    var txt = ((el && (el.getAttribute('data-for') || el.textContent)) || '').trim().toLowerCase();
    if (txt.indexOf('him') !== -1) { return 'him'; }
    if (txt.indexOf('her') !== -1) { return 'her'; }
    return '';
  }

  /* A tile may be wrapped in a cell that carries its span and accent. */
  function movable(tile) {
    return (tile.closest && tile.closest('.ejh-cell')) || tile;
  }

  /* ==================================================================
     VARIANT B - ask first, then lead with what they picked
     ================================================================== */
  function initAsk() {
    var heroBand = root.querySelector('[data-ejh-heroband]');
    /* The row of four small tiles. It carries data-ejh-row; ejh-band--strip
       belongs to a different block type this template does not use, and
       looking for that class is what made this whole variant a no-op. */
    var strip = root.querySelector('[data-ejh-row]') || root.querySelector('.ejh-band--strip');
    var hero = {
      him: root.querySelector('[data-ejh-hero="him"]'),
      her: root.querySelector('[data-ejh-hero="her"]')
    };
    var modal = document.querySelector('[data-vb-modal]');
    if (!heroBand || !strip || !hero.him || !hero.her) { return; }

    var small = { him: [], her: [] };
    var stripInner = strip.querySelector('.ejh-grid') || strip.querySelector('.ejh-strip') || strip;
    tilesIn(stripInner).forEach(function (tile) {
      var g = genderOf(tile);
      if (small[g]) { small[g].push(movable(tile)); }
    });

    /* One group: the hero full width, its two small tiles half and half
       beneath it. Rudi: "1 x Main Big Banner ... 2 x Smaller Blocks 50/50
       under it with the other two products." */
    function buildGroup(g) {
      var sec = document.createElement('section');
      sec.className = 'ejh-band ejh-band--flush ejh-vbgroup';
      sec.setAttribute('data-vb-group', g);
      sec.setAttribute('aria-label', g === 'him' ? 'For him' : 'For her');

      var grid = document.createElement('div');
      grid.className = 'ejh-grid';

      hero[g].style.setProperty('--ejh-span', '12');
      hero[g].classList.add('ejh-vbhero');
      grid.appendChild(hero[g]);

      /* The small tiles take their hero's accent, so the women's Discover
         chips are the Pebble purple like the hero's, not the men's steel
         blue. The strip's own purple rule is scoped to the strip's position
         in the page, and these tiles have just left it. Rudi: "the female
         block buttons on the videos should be the purple colour on the two
         smaller ones." */
      var accent = hero[g].style.getPropertyValue('--ejh-accent');
      small[g].forEach(function (node) {
        node.style.setProperty('--ejh-span', '6');
        if (accent) { node.style.setProperty('--ejh-accent', accent); }
        node.classList.add('ejh-vbsmall');
        grid.appendChild(node);
      });

      sec.appendChild(grid);
      return sec;
    }

    /* Built on demand, not up front. buildGroup MOVES the hero cells out of
       the band, and the "For them" answer needs that band intact so the
       carousel can run on it. */
    var group = null;
    function groups() {
      if (!group) { group = { him: buildGroup('him'), her: buildGroup('her') }; }
      return group;
    }

    function openerFor(g) {
      return document.getElementById(g === 'him' ? 'for-him' : 'for-her');
    }
    function shopAfter(opener) {
      var n = opener && opener.nextElementSibling;
      while (n && n.className.indexOf('ejh-shop') === -1) { n = n.nextElementSibling; }
      return n;
    }

    /* The whole page in one pass. insertBefore MOVES a node that is already
       in the document, so listing the sequence and walking it is enough --
       no removal step, and nothing can end up orphaned halfway through.

       The sequence is read off the brief directly: chosen group, then the
       offer/quote/press run exactly where the control page has it, then the
       chosen group's banner and products, then the same again for the other
       gender. Everything from "For them" down is left where it is. */
    function arrange(first) {
      var second = first === 'her' ? 'him' : 'her';
      var anchor = document.getElementById('for-them')
                || root.querySelector('.ejh-shop--pair');

      var g = groups();
      var seq = [
        g[first],
        root.querySelector('.ejh-offer'),
        root.querySelector('.ejh-quote'),
        root.querySelector('.ejh-logos'),
        openerFor(first), shopAfter(openerFor(first)),
        g[second],
        openerFor(second), shopAfter(openerFor(second))
      ].filter(Boolean);

      seq.forEach(function (node) {
        if (anchor) { root.insertBefore(node, anchor); }
        else { root.appendChild(node); }
      });

      if (heroBand.parentNode) { heroBand.parentNode.removeChild(heroBand); }
      if (strip.parentNode) { strip.parentNode.removeChild(strip); }
      root.setAttribute('data-vb-first', first);

      g[first].classList.add('ejh-vbgroup--lead');
      g[second].classList.remove('ejh-vbgroup--lead');

      /* Rudi: "the second for him / for her section banner is not necessary,
         we already have that banner in the video."

         He is right, and only about the SECOND one. The first group has the
         offer, the quote and the press strip between it and its banner, so
         the banner arrives as a fresh idea. The second group is followed
         immediately by its banner -- a full-width film of a man, then a
         full-width photograph of a man captioned FOR HIM -- and reads as
         the same thing twice.

         Hidden rather than removed: the nav scrolls to these by id, and a
         hidden element still answers to #for-him. */
      var dupe = openerFor(second);
      if (dupe) { dupe.classList.add('ejh-opener--dupe'); }
      var keep = openerFor(first);
      if (keep) { keep.classList.remove('ejh-opener--dupe'); }
      if (typeof window.ejhFitFold === 'function') { window.ejhFitFold(); }
      if (typeof window.ejhFitHeadlines === 'function') { window.ejhFitHeadlines(); }
      driveHeroes([hero[first], hero[second]]);
      window.dispatchEvent(new Event('resize'));
    }

    /* Rudi: "why doesn't the female big banner play on the b version?"

       Because the shared rotation will not run two tiles that touch, and in
       this layout a full-width hero touches BOTH tiles beneath it -- so its
       own group locks it out, and with only two clips running at a time the
       second group's hero waits its turn somewhere below the fold, plays to
       an empty screen, and is finished by the time anyone scrolls to it.

       A banner this size should not be queueing behind thumbnails. The two
       heroes come out of the rotation and get the treatment Rudi asked for
       on full-width banners: play the moment they are on screen, pause when
       they leave, and after one finishes hold the still for three seconds
       and go again. */
    function driveHeroes(cells) {
      if (!window.matchMedia('(min-width: 750px)').matches) { return; }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }

      var tiles = cells.map(function (c) { return c && c.querySelector('[data-ejh-tile]'); })
                       .filter(Boolean);
      if (!tiles.length) { return; }
      if (typeof window.ejhReleaseTiles === 'function') { window.ejhReleaseTiles(tiles); }

      tiles.forEach(function (tile) {
        var v = tile.querySelector('video');
        if (!v) { return; }
        var on = false;

        function start() {
          if (!on) { return; }
          if (!v.getAttribute('src')) {
            var src = v.getAttribute('data-src');
            if (!src) { return; }
            v.preload = 'auto';
            window.ejhSetSrc ? ejhSetSrc(v, src) : (v.src = src);
            v.load();
          }
          try { v.currentTime = 0; } catch (e) {}
          attempt(v,
            /* Reveal only once it is genuinely running: revealing first
               shows a paused first frame when the browser says no. */
            function () { tile.classList.add('is-ambient--live'); },
            function () { onRefusal(start); });
        }

        /* Rudi: "don't let the big banners ever stop playing, just make it
           loop indefinitely." So the three-second hold on the still is gone
           and the clip simply runs round. 'ended' never fires on a looping
           element, which is fine -- there is nothing left to do when it
           reaches the end. */
        v.loop = true;

        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var now = e.isIntersecting && e.intersectionRatio >= 0.3;
            if (now === on) { return; }
            on = now;
            if (on) { start(); }
            else {
              try { v.pause(); } catch (e2) {}
              tile.classList.remove('is-ambient--live');
            }
          });
        }, { threshold: [0, 0.3, 0.6] }).observe(tile);
      });
    }

    /* The fold fit now lives in ejh-home.js, shared by all three
       homepages, and measures the offer strip rather than predicting it.
       Variant B just has to say when the page has been rearranged. */

    function dismiss() {
      document.documentElement.classList.remove('ejh-vb-locked');
      if (!modal) { return; }
      modal.classList.add('is-done');
      window.setTimeout(function () {
        if (modal.parentNode) { modal.parentNode.removeChild(modal); }
      }, 420);
    }

    /* "For them" has no hero of its own to lead with, so rather than
       defaulting to the men's, Rudi asked for it to get variant C's
       treatment: the two big banners as one carousel with the four small
       tiles left under them, and the rest of the page as normal. */
    function choose(pick) {
      /* Remembered for 30 days, not one tab: on the live homepage a returning
         visitor should not be asked every visit. Three of 43 testers called
         the question annoying; all of them saw it once. */
      try { localStorage.setItem('ejh-vb-choice', JSON.stringify({ pick: pick, t: Date.now() })); } catch (e) {}
      if (pick === 'them') {
        root.setAttribute('data-vb-first', 'them');
        initCarousel();
      } else {
        arrange(pick === 'her' ? 'her' : 'him');
      }
      dismiss();
    }

    /* The logo film. It plays once and holds on the mark -- it is an intro,
       not a loop -- and only reveals itself once it is actually running, so
       a refused autoplay leaves the still logo showing instead of a black
       rectangle where the mark should be. */
    var film = document.querySelector('[data-vb-logo]');
    var filmVid = film && film.querySelector('video');
    if (filmVid) {
      filmVid.addEventListener('playing', function () { film.classList.add('is-live'); });
      var fp = filmVid.play();
      if (fp && fp.catch) {
        fp.catch(function () { onRefusal(function () {
          var again = filmVid.play();
          if (again && again.catch) { again.catch(function () {}); }
        }); });
      }
    }

    var prior = null;
    try {
      var saved = JSON.parse(localStorage.getItem('ejh-vb-choice') || 'null');
      if (saved && saved.pick && Date.now() - (saved.t || 0) < 30 * 24 * 3600 * 1000) { prior = saved.pick; }
    } catch (e) {}
    if (prior) { choose(prior); return; }

    if (!modal) { arrange('him'); return; }
    Array.prototype.forEach.call(modal.querySelectorAll('[data-vb-pick]'), function (btn) {
      btn.addEventListener('click', function () { choose(btn.getAttribute('data-vb-pick')); });
    });
    /* Esc does what the X does: "For them". */
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') { return; }
      if (!modal.parentNode || modal.classList.contains('is-done')) { return; }
      document.removeEventListener('keydown', onEsc);
      choose('them');
    });
  }

  /* ==================================================================
     VARIANT C - the two heroes as one full-width carousel
     ================================================================== */
  function initCarousel() {
    /* Not on a phone. The phone layout lifts the hero band and the strip
       into one grid (display: contents in the stylesheet) so heroes and
       small tiles can interleave, which leaves no track to slide; the
       arrows and lines were drawing against the page and landing over the
       row of small tiles. Rudi's brief tested only the control and the
       ask-first layout on mobile, so here template C IS the control. The
       heroes still play: the phone driver in ejh-home.js runs every
       visible clip, carousel or not. */
    if (!window.matchMedia('(min-width: 750px)').matches) { return; }
    var band = root.querySelector('[data-ejh-heroband]');
    if (!band) { return; }
    var track = band.querySelector('.ejh-grid');
    if (!track) { return; }

    var cells = Array.prototype.slice.call(track.children);
    if (cells.length < 2) { return; }

    if (band.hasAttribute('data-ejh-running')) { return; }
    band.setAttribute('data-ejh-running', '');
    band.setAttribute('data-ejh-carousel', '');
    cells.forEach(function (c) { c.style.setProperty('--ejh-span', '12'); });

    /* On template C the band is marked in Liquid and the rotation never took
       these tiles. Started from variant B's "For them" it is the other way
       round -- the rotation has had them since page load -- so ask for them
       back, or the two will fight over the same <video>. */
    if (typeof window.ejhReleaseTiles === 'function') {
      window.ejhReleaseTiles(band.querySelectorAll('[data-ejh-tile]'));
    }

    var at = 0;
    var guard = null;
    var seen = true;
    /* A clip that never loads must not strand the carousel, so every slide
       also carries a ceiling. The ended handler usually gets there first. */
    var CEILING = 14000;

    /* Arrows, so it is obvious the thing moves, and dots, so it is obvious
       how far there is to go. Rudi: "add buttons to show people can move
       next and previous, also add the two little dots so it shows there's
       two banners." */
    function arrow(dir, label, path) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ejh-caroarrow ejh-caroarrow--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
                    '<path d="' + path + '" fill="none" stroke="currentColor" ' +
                    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (dir === 'prev') { prev(); } else { next(); }
      });
      return b;
    }
    band.appendChild(arrow('prev', 'Previous banner', 'M15 5 L8 12 L15 19'));
    band.appendChild(arrow('next', 'Next banner', 'M9 5 L16 12 L9 19'));

    var dots = document.createElement('div');
    dots.className = 'ejh-carodots';
    cells.forEach(function (c, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ejh-carodot';
      b.setAttribute('aria-label', 'Show banner ' + (k + 1) + ' of ' + cells.length);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        show(k);
      });
      dots.appendChild(b);
    });
    band.appendChild(dots);

    function videoIn(cell) { return cell.querySelector('video'); }

    /* A tile's <video> is opacity:0 until something says it is running --
       .is-playing for hover, .is-ambient--live for a clip playing by itself.
       Nothing here was setting either, so the clips WERE playing, behind
       their own poster. Rudi: "none of the big banners are autoplaying when
       they are full width." They were; you just could not see them.

       is-ambient--live, not is-playing: the latter also swaps the headline
       for the hover paragraph, which is a mouse's job, not autoplay's. */
    function reveal(cell, on) {
      var tile = cell.querySelector('[data-ejh-tile]') || cell;
      tile.classList.toggle('is-ambient--live', !!on);
    }

    /* Tiles ship with a poster and data-src, and ejh-home.js attaches the
       real source when it decides to play one. The carousel decides for
       itself, so it has to do that attaching too -- otherwise play() is
       called on a <video> with no source and the slide just sits there. */
    function ready(v) {
      if (!v) { return null; }
      if (!v.getAttribute('src')) {
        var src = v.getAttribute('data-src');
        if (!src) { return null; }
        v.preload = 'auto';
        window.ejhSetSrc ? ejhSetSrc(v, src) : (v.src = src);
        v.load();
      }
      return v;
    }

    function show(n) {
      at = (n + cells.length) % cells.length;
      track.style.transform = 'translateX(' + (-at * 100) + '%)';

      cells.forEach(function (c, k) {
        c.classList.toggle('is-on', k === at);
        if (k === at) { return; }
        var v = videoIn(c);
        if (v) { try { v.pause(); } catch (e) {} }
        reveal(c, false);
      });

      Array.prototype.forEach.call(dots.children, function (d, k) {
        d.classList.toggle('is-on', k === at);
        d.setAttribute('aria-current', k === at ? 'true' : 'false');
      });

      /* Give the next slide's clip a head start, so the hand-over is not a
         poster sitting there while the video buffers. */
      ready(videoIn(cells[(at + 1) % cells.length]));

      run();
    }

    /* Rudi: "if the big banners are full width, play them immediately when
       they are visible; when they stop, move to the next."

       So the clip starts the moment the band is on screen rather than at
       page load, and stops when it scrolls away -- a banner playing to
       nobody is bandwidth for nothing, and on a laptop it is also fan
       noise. The advance itself is driven by the clip ending. */
    function run() {
      window.clearTimeout(guard);
      var v = videoIn(cells[at]);
      if (!seen) {
        if (v) { try { v.pause(); } catch (e) {} }
        reveal(cells[at], false);
        return;
      }
      if (v && ready(v)) {
        try { v.currentTime = 0; } catch (e) {}
        var slide = cells[at];
        attempt(v,
          function () { reveal(slide, true); },
          function () { onRefusal(function () { if (cells[at] === slide) { run(); } }); });
      }
      armFor(v);
    }

    /* One playthrough of the active clip. The ceiling is for the case where
       the length is NOT known -- a clip that never loads must not strand the
       carousel -- and must not be applied to a known duration, or a clip
       longer than the ceiling would be cut off part-way every time. */
    var LONGEST = 40000;
    function armFor(v) {
      window.clearTimeout(guard);
      var known = v && v.duration > 0 && isFinite(v.duration);
      var ms = known ? Math.min(Math.round(v.duration * 1000) + 120, LONGEST) : CEILING;
      guard = window.setTimeout(next, ms);
    }

    function next() { show(at + 1); }
    function prev() { show(at - 1); }

    /* The slide loops rather than stopping dead on its last frame, so the
       banner is never still. Advancing is therefore driven by the clip's own
       LENGTH rather than by 'ended', which a looping element never fires:
       one full playthrough, then the next banner. If the duration is not
       known yet the ceiling below still moves things along. */
    cells.forEach(function (c, k) {
      var v = videoIn(c);
      if (!v) { return; }
      v.loop = true;
      v.addEventListener('loadedmetadata', function () {
        if (k === at) { armFor(v); }
      });
    });

    /* Swipe, and the keyboard for anyone not using a touchscreen. */
    var x0 = null;
    band.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
    }, { passive: true });
    band.addEventListener('touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) < 45) { return; }
      if (dx < 0) { next(); } else { prev(); }
    }, { passive: true });
    band.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); }
      if (e.key === 'ArrowLeft') { prev(); }
    });

    if ('IntersectionObserver' in window) {
      seen = false;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var now = e.isIntersecting && e.intersectionRatio >= 0.3;
          if (now === seen) { return; }
          seen = now;
          run();
        });
      }, { threshold: [0, 0.3, 0.6] }).observe(band);
    }

    show(0);
    if (typeof window.ejhFitFold === 'function') { window.ejhFitFold(); }
    if (typeof window.ejhFitHeadlines === 'function') { window.ejhFitHeadlines(); }
  }

  /* Both are function declarations, so initAsk can call initCarousel for the
     "For them" answer regardless of the order they appear in. */
  if (mode === 'ask') { initAsk(); }
  if (mode === 'carousel') { initCarousel(); }
}());
